import { render, staticRenderFns } from "./OpportunityMedia.vue?vue&type=template&id=8850fc48"
import script from "./OpportunityMedia.vue?vue&type=script&lang=js"
export * from "./OpportunityMedia.vue?vue&type=script&lang=js"
import style0 from "./OpportunityMedia.vue?vue&type=style&index=0&id=8850fc48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports